import React, { useContext } from "react";
import "./SectionTitle.css";
import bgImage from "../assets/home_background.png";
import { LanguageContext } from "../LanguageContext";

const SectionTitle = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div
      className="section-title"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="section-title-text container">
        <h2>
          {language === "ko"
            ? "임신율 예측 자가 테스트"
            : "Testing fertility prediction in fertile patients"}
        </h2>
        <p>
          {language === "ko"
            ? "Testing fertility prediction in fertile patients"
            : "임신율 예측 자가 테스트"}
        </p>
      </div>
    </div>
  );
};

export default SectionTitle;
